/**
 * Event name for suggesting an asset in a swap.
 * @constant {string}
 */
const assetSuggestionEvent = 'swap:assetSuggestion'; // two-way

/**
 * Event name for suggesting a currency asset in a swap.
 * @constant {string}
 */
const currencyAssetSuggestionEvent = 'swap:currencyAssetSuggestion'; // two-way

/**
 * Event name for disregarding an asset in a swap.
 * @constant {string}
 */
const assetDisregardEvent = 'swap:assetDisregard'; // two-way

/**
 * Event name for disregarding a currency asset in a swap.
 * @constant {string}
 */
const currencyAssetDisregardEvent = 'swap:currencyAssetDisregard'; // two-way

/**
 * Event name for adding an asset to a swap.
 * @constant {string}
 */
const addAssetEvent = 'swap:addAsset'; // two-way

/**
 * Event name for removing an asset from a swap.
 * @constant {string}
 */
const removeAssetEvent = 'swap:removeAsset'; // two-way

/**
 * Event name for adding a currency asset to a swap.
 * @constant {string}
 */
const addCurrencyAssetEvent = 'swap:addCurrencyAsset'; // two-way

/**
 * Event name for removing a currency asset from a swap.
 * @constant {string}
 */
const removeCurrencyAssetEvent = 'swap:removeCurrencyAsset'; // two-way

/**
 * Event name for requesting a match in a swap.
 * @constant {string}
 */
const requestMatchEvent = 'swap:requestMatch'; // one-way

/**
 * Event name for canceling a match in a swap.
 * @constant {string}
 */
const cancelMatchEvent = 'swap:cancelMatch'; // one-way

/**
 * Event name for matching in a swap.
 * @constant {string}
 */
const matchEvent = 'swap:match'; // one-way

/**
 * Event name for submitting a proposal in a swap.
 * @constant {string}
 */
const submitProposalEvent = 'swap:submitProposal'; // two-way

/**
 * Event name for rejecting a proposal in a swap.
 * @constant {string}
 */
const rejectProposalEvent = 'swap:rejectProposal'; // two-way

/**
 * Event name for a proposal being submitted in a swap.
 * @constant {string}
 */
const proposalSubmittedEvent = 'swap:proposalSubmitted'; // one-way

/**
 * Event name for the maker finalizing a proposal in a swap.
 * @constant {string}
 */
const makerFinalizedProposalEvent = 'swap:makerFinalizedProposal'; // two-way

/**
 * Event name for a proposal being committed in a swap.
 * @constant {string}
 */
const committedProposalEvent = 'swap:committedProposal'; // two-way

/**
 * Event name for the taker finalizing a proposal in a swap.
 * @constant {string}
 */
const takerFinalizedProposalEvent = 'swap:takerFinalizedProposal'; // two-way

/**
 * Event name for a session being finalized in a swap.
 * @constant {string}
 */
const sessionFinalizedEvent = 'swap:sessionFinalized'; // two-way

/**
 * Event name for analytics in a swap.
 * @constant {string}
 */
const analyticsEvent = 'swap:analytics'; // one-way

/**
 * Event name for a session being completed in a swap.
 * @constant {string}
 */
const sessionCompletedEvent = 'swap:sessionCompletedEvent'; // one-way

export {
  analyticsEvent,
  sessionCompletedEvent,
  rejectProposalEvent,
  cancelMatchEvent,
  matchEvent,
  assetDisregardEvent,
  currencyAssetDisregardEvent,
  makerFinalizedProposalEvent,
  committedProposalEvent,
  currencyAssetSuggestionEvent,
  takerFinalizedProposalEvent,
  proposalSubmittedEvent,
  sessionFinalizedEvent,
  assetSuggestionEvent,
  removeCurrencyAssetEvent,
  addCurrencyAssetEvent,
  requestMatchEvent,
  addAssetEvent,
  removeAssetEvent,
  submitProposalEvent,
};
